import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

//import { ServiceOrder } from "../Serviceorder/serviceorder";

import { ServiceOrder } from '../Serviceorder/models/service-order';
import { ServiceOrderDetail } from '../Serviceorder/models/service-order-detail';

@Injectable({
  providedIn: 'root',
})
export class ServiceOrderService {
  private api : string = '/api/service-order';
  
  constructor(private http:HttpClient){}

  getServiceOrderList():Observable<ServiceOrder []>{
    return this.http.get<ServiceOrder[]>(this.api);
    
  } 

  createServiceOrder(serviceorder: ServiceOrder):Observable<ServiceOrder>{
    return this.http.post<ServiceOrder>(this.api, serviceorder);
  }

  deleteServiceOrderById(id : number):Observable<any>{
    return this.http.delete(this.api+'/'+id);
  }

  // Método para actualizar
  updateServiceOrder(serviceorder: ServiceOrder): Observable<ServiceOrder> {
    //return this.http.put<Customers>(this.api, customer); //(this.api+'/'+customer.id, customer);
    return this.http.post<ServiceOrder>(this.api, serviceorder)
  }

  // Método para obtener uno por ID (para cargar el formulario)
  getServiceOrder(id: number): Observable<ServiceOrder> {
    return this.http.get<ServiceOrder>(this.api+'/'+id);
  }

}
